import { Box, Button, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { SentIcon } from 'src/components/sent-icon/sentIcon';
import { useToaster } from 'src/utils/toaster/toasterContext';
import ChangePasswordForm from './changePasswordForm';
import { useTranslation } from 'react-i18next';

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

export default function ChangePassword() {
  const { t: translate } = useTranslation();
  const [password, setPassword] = useState('');
  const { showToast } = useToaster();
  const [sent, setSent] = useState(false);
  const [token, setToken] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let token = new URLSearchParams(params).get('token');
    if (!token) {
      showToast(translate('change_password.token_invalid'), 'e');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } else setToken(token);
  });
  const navigateToLogin = () => {
    setSent(true);
    setTimeout(() => {
      navigate('/login');
    }, 2000);
  };
  return (
    <div title={translate('change_password.reset_password')} sx={{ height: 1 }}>
      <RootStyle>
        <Container>
          <Box sx={{ maxWidth: 480, mx: 'auto' }}>
            {!sent ? (
              <>
                <Typography variant="h3" paragraph>
                  {translate('profile.change_password.title')}
                </Typography>
                <Typography sx={{ color: 'text.secondary', mb: 5 }}>
                  {translate('change_password.enter_password_to_change')}
                </Typography>

                <ChangePasswordForm
                  onSent={() => navigateToLogin()}
                  onGetPassword={(value) => setPassword(value)}
                  token={token}
                />
              </>
            ) : (
              <Box sx={{ textAlign: 'center' }}>
                <SentIcon sx={{ mb: 5, mx: 'auto', height: 160 }} />

                <Typography variant="h3" gutterBottom>
                  {translate('change_password.password_changed')}
                </Typography>

                <Button size="large" variant="contained" component={RouterLink} to={'/'} sx={{ mt: 5 }}>
                  {translate('change_password.go_to_login')}
                </Button>
              </Box>
            )}
          </Box>
        </Container>
      </RootStyle>
    </div>
  );
}
